










































import { DashboardService, Evento } from "@/services/dashboard.service";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { dateTime } from "@/shared/filters";

@Component({
  filters: { dateTime }
})
export default class EventosTabelaSuporte extends Vue {
  ListaEventos: Evento[] | null = null;
  loadingEventos = false;
  intervalId = 0;

  mounted() {
    this.carregarListaEventos();
  }

  async carregarListaEventos() {
    this.loadingEventos = true;
    this.ListaEventos = await DashboardService.ListaEventos().finally(
      () => (this.loadingEventos = false)
    );
  }
  
  beforeDestroy() {
    clearInterval(this.intervalId);
  }
}
